export enum RefractoryClassificationClass {
  Brick = 'Brick',
  Unshaped = 'Unshaped',
  Mortar = 'Mortar',
  Precast = 'Precast',
  Others = 'Others'
}

export enum RefractoryCastableDeliveryCondition {
  DryForAdditionOfWater = 'DryForAdditionOfWater',
  MoistReadyForUse = 'MoistReadyForUse',
  DryReadyForUse = 'DryReadyForUse',
  DryForAdditionOfExtraBinder = 'DryForAdditionOfExtraBinder'
}

export enum RefractoryPlacingMethod {
  CastingGunning = 'CastingGunning',
  CastingVibrating = 'CastingVibrating',
  Gunning = 'Gunning',
  GunningRamming = 'GunningRamming',
  Injecting = 'Injecting',
  Patching = 'Patching',
  Pumping = 'Pumping',
  Ramming = 'Ramming',
  RoddingTrowelling = 'RoddingTrowelling',
  SelfFlowing = 'SelfFlowing',
  Shotcreting = 'Shotcreting',
  Spraying = 'Spraying',
  Trowelling = 'Trowelling'
}

export enum RefractoryPhysicalDataType {
  AbrasionResistance = 'AbrasionResistance',
  BulkDensity = 'BulkDensity',
  ColdCrushingStrength = 'ColdCrushingStrength',
  HotModulusOfRupture = 'HotModulusOfRupture',
  ModulusOfRupture = 'ModulusOfRupture',
  PermanentLinearChange = 'PermanentLinearChange',
  Porosity = 'Porosity',
  ThermalConductivity = 'ThermalConductivity',
  ThermalExpansion = 'ThermalExpansion',
  ThermalShockResistance = 'ThermalShockResistance'
}

export enum RefractoryChemicalDataType {
  CaO = 'CaO',
  MgO = 'MgO',
  SiO2 = 'SiO2',
  Fe2O3 = 'Fe2O3',
  Al2O3 = 'Al2O3',
  Mn2O3 = 'Mn2O3',
  Cr2O3 = 'Cr2O3',
  TiO2 = 'TiO2',
  P2O5 = 'P2O5',
  ZrO2 = 'ZrO2',
  SiC = 'SiC',
  SiO2PlusSiC = 'SiO2PlusSiC',
  Al2O3PlusSiC = 'Al2O3PlusSiC',
  K2O = 'K2O',
  Na2O = 'Na2O',
  B2O3 = 'B2O3',
  F = 'F',
  Cl = 'Cl',
  LOI = 'LOI',
  H2O = 'H2O',
  CFree = 'CFree',
  CO2 = 'CO2',
  Al = 'Al',
  Si = 'Si',
  BaO = 'BaO'
}
